import { Component } from '@angular/core';

@Component({
  selector: 'app-inquiries',
  templateUrl: './inquiries.component.html',
  styleUrls: ['./inquiries.component.scss']
})
export class InquiriesComponent {

  value!: number;
  confirmRange: boolean = false

  listSchools: any[] = [
    {name: 'school 1', cost: 15000},
    {name: 'school 2', cost: 17000},
    {name: 'school 3', cost: 20000},
  ]

}
